export enum HandlerShape {
  circle,
  strip,
}
